<template>
  <div class="d-flex flex-column px-4 px-md-0 justify-center align-center">
    <div class="mb-4">
      <slot name="icon">
        <v-icon color="green" size="42" class="mb-4">
          check_circle_outline
        </v-icon>
      </slot>
    </div>

    <div class="mb-1">
      <slot name="title">
        <span class="text-subtitle-1 text-md-h6 font-weight-bold text-center">
          Alert title
        </span>
      </slot>
    </div>

    <div style="margin-bottom: 48px;">
      <slot name="description">
        <span
          class="text-subtitle-2 text-md-subtitle-1 font-weight-regular grey--text text--darken-1 text-center"
        >
          Alert description
        </span>
      </slot>
    </div>

    <div>
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomErrorMessage",
};
</script>

<style scoped>
</style>